
$( document ).ready(function() {
$('body').on('click', '.variant-input', function() {
var variant_id = $(this).attr("data-variant-id");
var index = $(this).attr("data-index");
if(index=='option1'){
var color = $(this).attr("data-value");
var size = $('.variant-input-wrap[data-index="option2"]').find("input[type=radio]:checked").val();

}else if(index=='option2'){
  var size = $(this).attr("data-value");
 var color = $('.variant-input-wrap[data-index="option1"]').find("input[type=radio]:checked").val();

}
var option1 = $('.variant-input-wrap[data-index="option1"]').find("input[type=radio]:checked").val();
var option2 = $('.variant-input-wrap[data-index="option2"]').find("input[type=radio]:checked").val();  
var option3 = $('.variant-input-wrap[data-index="option3"]').find("input[type=radio]:checked").val();

var options ='';
if(option1 != '' && option1 != undefined){
   if(options!=''){ options +=" / "; }
  options +=option1;
}
if(option2 != '' && option2 != undefined){
  if(options!=''){ options +=" / "; }
  options +=option2;
}

 if(option3 != '' && option3 != undefined){
  if(options!=''){ options +=" / "; }
  options +=option3;
}
console.log(options);
var option =options;
//console.log(option);
$(".product-single__variants-common option").removeAttr("selected");
var v_id = 0;
$( ".product-single__variants-common option" ).each(function( index ) {
if($.trim($(this).html()) == $.trim(option)){
  $(this).attr("selected","selected");
  var v_id = $(this).val();
}

});

var variant_id = $( ".product-single__variants-common" ).val();

$(".partners").hide();
$(".partners-usa").hide();
$(".partners-measurmeents").hide();
$(".usa_dealer").hide();
$(".european_dealer").hide();
$(".partners-asia").hide();
$(".asia_dealer").hide();
$(".partners-global").hide();
$(".global_dealer").hide();

if(variant_id){
$(".custm_styles-"+variant_id).show();
$(".custm_styles_usa-"+variant_id).show();
$(".cstm_measurements-"+variant_id).show();
$(".custm_styles_asia-"+variant_id).show();
$(".custm_styles_global-"+variant_id).show();

  if($(".custm_styles_usa-"+variant_id+" li").length > 0){
    $(".usa_dealer").show();
  }else{
     $(".usa_dealer").hide();
  }

if($(".custm_styles-"+variant_id+" li").length > 0){
    $(".european_dealer").show();
  }else{
     $(".european_dealer").hide();
  }

  if($(".custm_styles_asia-"+variant_id+" li").length > 0){
    $(".asia_dealer").show();
}else{
    $(".asia_dealer").hide();
}
  if($(".custm_styles_global-"+variant_id+" li").length > 0){
    $(".global_dealer").show();
}else{
    $(".global_dealer").hide();
}
  
}

 if(variant_id != 0){
    
    if($(".cstm_measurements-"+variant_id+" li").length == 0 && $.trim($(".cstm_measurements-"+variant_id+" .cstm_weight .hidden").html()) == ""){
      $(".collapsibles-wrapper.cstm_collapsible_sizes").hide(); 
     }else{
     $(".collapsibles-wrapper.cstm_collapsible_sizes").show(); 
     }
  }else{
   $(".collapsibles-wrapper.cstm_collapsible_sizes").hide();
  }

});
});

var variant_id = $( ".product-single__variants-common" ).val();

//console.log($('.partners-measurmeents').is(':visible'));
  if(variant_id != 0){
    console.log($(".cstm_measurements-"+variant_id+" li").length);
   if($(".cstm_measurements-"+variant_id+" li").length == 0 && $.trim($(".cstm_measurements-"+variant_id+" .cstm_weight .hidden").html()) == ""){
   $(".collapsibles-wrapper.cstm_collapsible_sizes").hide(); 
     }else{
     $(".collapsibles-wrapper.cstm_collapsible_sizes").show(); 
     } 
  }else{
   $(".collapsibles-wrapper.cstm_collapsible_sizes").hide();
  }
$('.cstm_sizes_1').find('ul').each(function(){
 var weight = $("li", this).text();
 if(weight.length <= 0){
    $(this).hide();
 }
});
if(!$('.cstm_sizes_1').find('ul:visible').length){
  $('.cstm_sizes_1').hide();
}
$('.cstm_sizes_2').find('ul').each(function(){
 var weight = $("li", this).text();
 if(weight.length <= 0){
    $(this).hide();
 }
});
if(!$('.cstm_sizes_2').find('ul:visible').length){
  $('.cstm_sizes_2').hide();
}




         